import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { ConfigProvider } from "../config/config";
import { resolve } from "url";
import { PhotoLibrary } from '@ionic-native/photo-library';
import { P } from "@angular/core/src/render3";

@Injectable()
export class StrackerProvider {

    data = null;

    constructor(private config: ConfigProvider, private storage: Storage, private library: PhotoLibrary) {
        // this.library.saveImage()
    }

    saveUncompletedData() {

    }

    checkForExistance(key) {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let table = data.includes(key);
                if (table) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }

    getSaved(type): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.get(type).then((data) => resolve(JSON.parse(data)));
        });
    }

    saveData(data, type): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.set(type, JSON.stringify(data)).then(() => resolve(null));
        });
    }

    //TODO: code duplicates
    //pushEventRegistration and pushDataFinished and pushDataUnfinished

    pushDataFinished(obj): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let existed = [];
                existed.push(obj);
                let table = data.includes("stracker-model-finished");
                if (table) {
                    this.getSaved("stracker-model-finished").then((data) => {
                        existed = data;
                        existed.push(obj);
                        this.saveData(existed, "stracker-model-finished");
                    });
                } else {
                    this.saveData(existed, "stracker-model-finished");
                }

            })
        });
    }

    writeDataFinished(obj): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let existed = [];
                let table = data.includes("stracker-model-finished");
                if (table) {
                    this.getSaved("stracker-model-finished").then((data) => {
                        console.log('data-stracker-model-finished: ' + JSON.stringify(data));
                        let filtered = data.filter((e) => e.eventId != -1);
                        console.log('filtered-data-stracker-model-finished: ' + JSON.stringify(filtered));

                        if (filtered.length != 0) {
                            existed = Object.assign([], filtered);
                        }

                        existed.push(obj);
                        this.saveData(existed, "stracker-model-finished").then(() => resolve(null));
                    });
                } else {
                    existed.push(obj);
                    this.saveData(existed, "stracker-model-finished").then(() => resolve(null));
                }

            })
        });
    }

    pushEventRegistration(obj) {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let existed = [];
                existed.push(obj);
                let table = data.includes("event-registration");
                if (table) {
                    this.getSaved("event-registration").then((data) => {
                        let filtered = data.filter((e) => e.eventId != obj.eventId || e.token != obj.token);

                        if (filtered.length != 0) {
                            existed = filtered;
                            existed.push(obj);
                        }

                        this.saveData(existed, "event-registration").then(() => {
                            resolve(null);
                        })
                    });
                } else {
                    this.saveData(existed, "event-registration").then(() => {
                        resolve(null);
                    })
                }

            })
        });
    }

    pushDataNotFinished(obj): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let existed = [];
                existed.push(obj);
                let table = data.includes("stracker-model-notfinished");
                if (table) {
                    this.getSaved("stracker-model-notfinished").then((data: TrackerModel[]) => {
                        let filtered = data.filter((e) => e.eventId != obj.eventId || e.token != obj.token);

                        if (filtered.length != 0) {
                            existed = filtered;
                            existed.push(obj);
                        }

                        this.saveData(existed, "stracker-model-notfinished");
                    });
                } else {
                    this.saveData(existed, "stracker-model-notfinished");
                }

            })
        });
    }

    remove() {
        this.storage.remove('stracker-model-notfinished');
    }

    getFastestFinishResult(eventId: number, token: string): Promise<TrackerModel> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((values) => {
                let table = values.includes('stracker-model-finished');
                if (table) {
                    this.getSaved("stracker-model-finished").then((data: TrackerModel[]) => {
                        console.log('data: ', JSON.stringify(data));
                        let results = data.filter((e) => e.eventId === eventId && e.token === token).sort((a, b) => a.time - b.time);
                        console.log('results: ', results);
                        resolve(results[0]);
                    });
                } else {
                    resolve(null);
                }
            });
        });
    }

    getResultPreload(eventId: number, token: string): Promise<TrackerModel> {
        console.log('getResultPreload- token: ' + token);
        console.log('getResultPreload- eventId: ' + eventId);
        // check if there is not finished result
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((values) => {
                console.log('values: ', values);
                let table = values.includes('stracker-model-notfinished');
                if (table) {
                    this.getSaved("stracker-model-notfinished").then((data: TrackerModel[]) => {
                        console.log('data: ', JSON.stringify(data));
                        let results = data.filter((e) => e.eventId === eventId && e.token === token);
                        console.log('results: ', JSON.stringify(results));
                        if (results.length > 0) {
                            resolve(results[0]);
                        } else {
                            this.getFastestFinishResult(eventId, token).then((model) => resolve(model));
                        }
                    });
                } else {
                    this.getFastestFinishResult(eventId, token).then((model) => resolve(model));
                }
            })
        });
    }

}

//event-registration: table
//stracker-model-notfinished: table
//stracker-model-finished: table

export interface RouteMarathon {
    hasRoute: boolean;
    fullPath?: any[];
}

export interface EventRegistrationModel {
    eventId: number;
    id: number;
}

export interface TrackerModel {
    token: string | number;
    eventId: number;
    time: number;
    finished: boolean;
    distance: number;
    average_speed: string | number;
    average_pace: string;
    path?: any[];
    splited?: any[];
}


// WEBPACK FOOTER //
// /src/providers/stracker/stracker.ts